(function() {
  var KEYWORD = 'ledermuster';
  var WARNING = '\u26a0\ufe0f Sie k\u00f6nnen nur ein Ledermuster pro Stuhl bestellen.';

  /* Save originals early */
  var origFetch = window.fetch;
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  function showToast() {
    var el = document.getElementById('ledermuster-toast');
    if (el) el.remove();
    var div = document.createElement('div');
    div.id = 'ledermuster-toast';
    div.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:99999;background:#fff8e1;border:1px solid #ffe082;border-radius:8px;padding:14px 24px;font-size:14px;color:#6d4c00;box-shadow:0 4px 20px rgba(0,0,0,.15);max-width:90vw;text-align:center;';
    div.textContent = WARNING;
    document.body.appendChild(div);
    setTimeout(function() { div.remove(); }, 4000);
  }

  /* Get product data from the page JSON */
  function getProductData() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  /* Check if entire product is Ledermuster (title/handle) */
  function isFullLedermusterProduct() {
    var p = getProductData();
    if (!p) return false;
    if ((p.title || '').toLowerCase().indexOf(KEYWORD) > -1) return true;
    if ((p.handle || '').toLowerCase().indexOf(KEYWORD) > -1) return true;
    return window.location.pathname.toLowerCase().indexOf(KEYWORD) > -1;
  }

  /* Get variant IDs that are Ledermuster */
  function getLedermusterVariantIds() {
    var p = getProductData();
    if (!p || !p.variants) return [];
    return p.variants
      .filter(function(v) { return (v.title || '').toLowerCase().indexOf(KEYWORD) > -1; })
      .map(function(v) { return v.id; });
  }

  /* Check if a given variant ID is a Ledermuster variant on this page */
  function isLedermusterVariantId(variantId) {
    if (!variantId) return false;
    var lmIds = getLedermusterVariantIds();
    return lmIds.indexOf(parseInt(variantId)) > -1 || lmIds.indexOf(variantId) > -1;
  }

  /* Get the currently selected variant ID */
  function getCurrentVariantId() {
    var input = document.querySelector('[data-section-type="product"] input[name="id"]');
    if (input) return parseInt(input.value);
    return null;
  }

  /* Check if current page has any Ledermuster variant */
  function pageHasLedermuster() {
    return isFullLedermusterProduct() || getLedermusterVariantIds().length > 0;
  }

  /* Check if the currently selected variant is Ledermuster */
  function isCurrentVariantLedermuster() {
    if (isFullLedermusterProduct()) return true;
    var vid = getCurrentVariantId();
    return vid ? isLedermusterVariantId(vid) : false;
  }

  /* Disable or enable the add-to-cart button */
  function setButtonDisabled(disabled) {
    var btn = document.querySelector('[data-add-to-cart]');
    if (!btn) btn = document.querySelector('.product__block--buttons .btn--add-to-cart');
    if (!btn) btn = document.querySelector('.product__block--buttons button[type="submit"]');
    if (!btn) return;
    if (disabled) {
      btn.setAttribute('disabled', 'disabled');
      btn.style.opacity = '0.4';
      btn.style.pointerEvents = 'none';
      var note = document.getElementById('lm-already-in-cart');
      if (!note) {
        note = document.createElement('div');
        note.id = 'lm-already-in-cart';
        note.style.cssText = 'color:#6d4c00;font-size:13px;margin-top:8px;';
        note.textContent = WARNING;
        var submitBlock = btn.closest('.product__submit__buttons') || btn.closest('.product__submit');
        if (submitBlock) {
          submitBlock.parentNode.insertBefore(note, submitBlock.nextSibling);
        }
      }
    } else {
      btn.removeAttribute('disabled');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      var note = document.getElementById('lm-already-in-cart');
      if (note) note.remove();
    }
  }

  /* Check cart and disable button if Ledermuster already in cart */
  function checkCartAndDisableButton() {
    if (!isCurrentVariantLedermuster()) {
      setButtonDisabled(false);
      return;
    }
    var p = getProductData();
    if (!p) return;
    var productId = p.id;

    origFetch.call(window, '/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var found = false;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.product_id === productId) {
          var title = ((item.product_title || '') + ' ' + (item.variant_title || '')).toLowerCase();
          if (title.indexOf(KEYWORD) > -1) {
            found = true;
            break;
          }
        }
      }
      setButtonDisabled(found);
    }).catch(function() {});
  }

  /* === 1. Force qty=1 when Ledermuster variant is selected === */
  function lockQuantity() {
    var isLM = isCurrentVariantLedermuster();
    var submitItem = document.querySelector('.product__submit__item--inline');
    if (!isLM) {
      /* Restore grid when switching away from Ledermuster */
      if (submitItem) submitItem.style.gridTemplateColumns = '';
      return;
    }
    var popout = document.querySelector('.product__block--buttons .select-popout');
    if (popout) popout.style.display = 'none';
    if (submitItem) submitItem.style.gridTemplateColumns = '1fr';
    var inputs = document.querySelectorAll('.product__block--buttons input[name="quantity"]');
    inputs.forEach(function(input) {
      input.value = 1;
      input.max = 1;
      input.min = 1;
      input.readOnly = true;
    });
  }

  function init() {
    lockQuantity();
    checkCartAndDisableButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('theme:variant:change', function() {
    setTimeout(init, 50);
  });

  /* === 2. Intercept fetch === */
  window.fetch = function(input, init2) {
    var url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');
    var method = ((init2 && init2.method) || (typeof input === 'object' && input.method) || 'GET').toUpperCase();

    /* --- /cart/add: check if adding a Ledermuster variant --- */
    if (method === 'POST' && url.indexOf('/cart/add') > -1) {
      var body = (init2 && init2.body) ? init2.body : null;
      var addingLedermuster = false;
      var productId = null;
      var p = getProductData();
      if (p) productId = p.id;

      /* Check if request body contains a Ledermuster variant ID */
      if (body && typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed.items && Array.isArray(parsed.items)) {
            parsed.items.forEach(function(item) {
              if (isLedermusterVariantId(item.id)) addingLedermuster = true;
              if (item.quantity > 1) item.quantity = 1;
            });
            if (addingLedermuster) init2 = Object.assign({}, init2, { body: JSON.stringify(parsed) });
          }
          if (parsed.id && isLedermusterVariantId(parsed.id)) {
            addingLedermuster = true;
            if (parsed.quantity > 1) {
              parsed.quantity = 1;
              init2 = Object.assign({}, init2, { body: JSON.stringify(parsed) });
            }
          }
        } catch(e) {}
      }
      /* Also check current variant on page as fallback */
      if (!addingLedermuster && isCurrentVariantLedermuster()) {
        addingLedermuster = true;
      }

      if (addingLedermuster && productId) {
        /* Check cart — block if Ledermuster from same product already there */
        return origFetch.call(window, '/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            for (var i = 0; i < cart.items.length; i++) {
              var item = cart.items[i];
              if (item.product_id === productId) {
                var title = ((item.product_title || '') + ' ' + (item.variant_title || '')).toLowerCase();
                if (title.indexOf(KEYWORD) > -1) {
                  showToast();
                  setButtonDisabled(true);
                  return new Response(JSON.stringify({
                    status: 422,
                    message: WARNING,
                    description: WARNING
                  }), { status: 422, headers: { 'Content-Type': 'application/json' } });
                }
              }
            }
            /* Not in cart yet — allow, then disable button */
            return origFetch.call(window, input, init2).then(function(response) {
              setTimeout(function() {
                setButtonDisabled(true);
                checkCartAndDisableButton();
              }, 500);
              return response;
            });
          })
          .catch(function() {
            return origFetch.call(window, input, init2);
          });
      }
    }

    /* --- /cart/update and /cart/change: cap qty to 1 for ledermuster items --- */
    if (method === 'POST' && (url.indexOf('/cart/update') > -1 || url.indexOf('/cart/change') > -1)) {
      var body2 = (init2 && init2.body) ? init2.body : null;
      if (body2 && typeof body2 === 'string') {
        try {
          var p2 = JSON.parse(body2);
          if (p2.quantity && p2.quantity > 1) {
            return origFetch.call(window, '/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
              var id = p2.id || p2.line;
              for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                var isMatch = (item.key === id || item.variant_id == id || (i + 1) == id);
                var isLM = ((item.product_title || '') + ' ' + (item.variant_title || '')).toLowerCase().indexOf(KEYWORD) > -1;
                if (isMatch && isLM && p2.quantity > 1) {
                  p2.quantity = 1;
                  showToast();
                  init2 = Object.assign({}, init2, { body: JSON.stringify(p2) });
                  break;
                }
              }
              return origFetch.call(window, input, init2);
            });
          }
        } catch(e) {}
      }
    }

    return origFetch.call(window, input, init2);
  };

  /* === 3. Intercept XMLHttpRequest === */
  XMLHttpRequest.prototype.open = function(method, url) {
    this._lm_url = url;
    this._lm_method = (method || '').toUpperCase();
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    var self = this;
    if (this._lm_method === 'POST' && this._lm_url && this._lm_url.indexOf('/cart/add') > -1) {
      var addingLedermuster = false;
      var productId = null;
      var p = getProductData();
      if (p) productId = p.id;

      if (body && typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed.id && isLedermusterVariantId(parsed.id)) addingLedermuster = true;
          if (parsed.items) {
            parsed.items.forEach(function(item) {
              if (isLedermusterVariantId(item.id)) addingLedermuster = true;
              if (item.quantity > 1) item.quantity = 1;
            });
          }
          if (parsed.quantity && parsed.quantity > 1) parsed.quantity = 1;
          body = JSON.stringify(parsed);
        } catch(e) {}
      }
      if (!addingLedermuster && isCurrentVariantLedermuster()) {
        addingLedermuster = true;
      }

      if (addingLedermuster && productId) {
        var checkXhr = new XMLHttpRequest();
        origOpen.call(checkXhr, 'GET', '/cart.js', true);
        checkXhr.onload = function() {
          try {
            var cart = JSON.parse(checkXhr.responseText);
            for (var i = 0; i < cart.items.length; i++) {
              var item = cart.items[i];
              if (item.product_id === productId) {
                var title = ((item.product_title || '') + ' ' + (item.variant_title || '')).toLowerCase();
                if (title.indexOf(KEYWORD) > -1) {
                  showToast();
                  setButtonDisabled(true);
                  Object.defineProperty(self, 'status', { value: 422, configurable: true });
                  Object.defineProperty(self, 'responseText', { value: JSON.stringify({ message: WARNING }), configurable: true });
                  Object.defineProperty(self, 'readyState', { value: 4, configurable: true });
                  if (self.onreadystatechange) self.onreadystatechange();
                  if (self.onload) self.onload();
                  return;
                }
              }
            }
            origSend.call(self, body);
          } catch(e) {
            origSend.call(self, body);
          }
        };
        checkXhr.onerror = function() { origSend.call(self, body); };
        origSend.call(checkXhr, null);
        return;
      }
    }
    return origSend.call(this, body);
  };

  /* === 4. Hide inventory notice + qty selector for Ledermuster === */
  function handleLedermuster() {
    var p = getProductData();
    if (!p) return;

    if (isFullLedermusterProduct()) {
      var popout = document.querySelector('.product__block--buttons .select-popout');
      if (popout) popout.style.display = 'none';
      var submitItem = document.querySelector('.product__submit__item--inline');
      if (submitItem) submitItem.style.gridTemplateColumns = '1fr';
      var qtyInput = document.querySelector('.product__block--buttons input[name="quantity"]');
      if (qtyInput) { qtyInput.value = 1; qtyInput.max = 1; }
      var invWrapper = document.querySelector('[data-remaining-wrapper]');
      if (invWrapper) invWrapper.style.display = 'none';
      return;
    }

    var lmIds = getLedermusterVariantIds();
    if (lmIds.length === 0) return;

    var remEl = document.querySelector('[data-product-remaining-json]');
    if (remEl) {
      try {
        var rem = JSON.parse(remEl.textContent);
        lmIds.forEach(function(vid) { rem[vid] = 'in'; });
        remEl.textContent = JSON.stringify(rem);
      } catch(e) {}
    }

    function onVariantChange() {
      var vid = getCurrentVariantId();
      var isLM = vid ? lmIds.indexOf(vid) > -1 : false;
      var wrapper = document.querySelector('[data-remaining-wrapper]');
      if (wrapper) wrapper.style.display = isLM ? 'none' : '';
      var popout = document.querySelector('.product__block--buttons .select-popout');
      if (popout) popout.style.display = isLM ? 'none' : '';
      var submitItem = document.querySelector('.product__submit__item--inline');
      if (submitItem) submitItem.style.gridTemplateColumns = isLM ? '1fr' : '';
      var qi = document.querySelector('.product__block--buttons input[name="quantity"]');
      if (qi && isLM) { qi.value = 1; qi.max = 1; }
      else if (qi && !isLM) { qi.removeAttribute('max'); }
    }

    var section = document.querySelector('[data-section-type="product"]');
    if (section) {
      section.addEventListener('theme:variant:change', onVariantChange);
    }
    onVariantChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleLedermuster);
  } else {
    handleLedermuster();
  }
})();
